import PropTypes from 'prop-types'
import React from 'react'

import StarRating from '../../../shared/components/starRating'
import EnhancedLazyLoad from '../../../shared/components/enhancedLazyLoad'
import MetaCategories from '../../pages/search/result/metaCategories'
import TrendingSash from './common/trendingSash'
import MagnifierConfigurator from '../../../shared/components/magnifier/configurator'
import Overlay from '../../../shared/components/overlay'
import BarChartIcon from '../../../shared/components/icons/barChart'
import ItemActions from './common/itemActions'

const ItemCardListDefault = ({
  item,
  onAddToFavourites,
  rank,
  onAddToCollections,
  onItemLinkClick = () => {},
  onAddToCart = () => {},
  muted,
  muteVideo
}) => {
  const firstVisibleImagesCount = 5
  return (
    <div>
      <div className="product-list__columns-container">
        <div className="product-list__column-detail">
          <div className="product-list__item-thumbnail">
            <div className="item-thumbnail">
              <Overlay
                position="side"
                content={
                  <MagnifierConfigurator
                    item={item}
                    videoMuted={muted}
                    muteVideo={muteVideo}
                  />
                }
              >
                <div
                  className="item-thumbnail__image"
                  data-test-selector="item-thumbnail-default"
                >
                  <a
                    href={`${item.url}?s_rank=${rank}`}
                    onClick={onItemLinkClick}
                    className="item-thumbnail__link"
                    aria-label={item.name}
                  >
                    <EnhancedLazyLoad
                      height="100%"
                      once
                      offset={400}
                      disabled={rank <= firstVisibleImagesCount}
                    >
                      <img
                        alt={item.name}
                        className="preload no_preview landscape-image-magnifier"
                        height="80"
                        src={item.ui.smallPreviewUrl}
                        title={item.name}
                        width="80"
                      />
                    </EnhancedLazyLoad>
                  </a>
                  {item.previews.live_site ? (
                    <div className="item-thumbnail__preview">
                      <a
                        href={item.previews.live_site.url}
                        target="_blank"
                        className="item-thumbnail__preview-link"
                      >
                        Live preview
                      </a>
                    </div>
                  ) : null}
                </div>
              </Overlay>
            </div>
          </div>

          <div className="product-list__adjacent-thumbnail">
            <h3 className="product-list__heading">
              <a
                className="fds-c-text-link -color-inherit -decoration-reversed"
                href={`${item.url}?s_rank=${rank}`}
                onClick={onItemLinkClick}
              >
                {item.name}
              </a>
            </h3>

            <div className="product-list__price">
              <p className="fds-c-text-body -size-m -color-inherit -weight-bold fds-u-m0">
                ${item.ui.price}{' '}
                {item.ui.pricePeriod && (
                  <span className="fds-c-text-body -size-xs fds-u-m0">
                    /{item.ui.pricePeriod}
                  </span>
                )}
              </p>
            </div>

            <div className="product-list__info">
              <div className="product-list__info-author">
                <a
                  className="fds-c-text-link -color-default -decoration-reversed"
                  href={item.author_url}
                >
                  {item.author_username}
                </a>
              </div>

              <div className="product-list__info-rating">
                {item.rating.rating ? (
                  <StarRating
                    rating={item.rating.rating}
                    className="star-rating--search"
                  />
                ) : null}
                {item.rating.rating && item.rating.count
                  ? `${item.rating.count} ratings`
                  : null}
              </div>

              {item.number_of_sales ? (
                <div className="product-list__info-sale">
                  <span className="product-list__info-sale-glyph">
                    <BarChartIcon />
                  </span>
                  {item.number_of_sales} Sales
                </div>
              ) : null}
            </div>
          </div>

          <div className="fds-u-clear">
            <div className="product-list__item-thumbnail-actions">
              <div className="item-thumbnail-actions -width-full">
                <ItemActions
                  item={item}
                  onAddToFavourites={onAddToFavourites}
                  onAddToCollections={onAddToCollections}
                  onAddToCart={onAddToCart}
                  nonAudioTheme
                />
              </div>
            </div>
          </div>
        </div>

        <div className="product-list__column-category">
          <p className="fds-c-text-body -size-xs fds-u-m0">
            <MetaCategories
              classification={item.classification}
              className="meta-categories -no-slash"
            />
            <br /> {item.summary}
          </p>
        </div>

        <div className="product-list__column-price">
          <p className="product-list__price-desktop">${item.ui.price}</p>
          {item.ui.pricePeriod && (
            <p className="fds-c-text-body -size-xs fds-u-m0">
              /{item.ui.pricePeriod}
            </p>
          )}
          <div className="product-list__info-desktop">
            {item.rating.rating ? (
              <StarRating
                rating={item.rating.rating}
                className="star-rating--search"
              />
            ) : null}
            {item.rating.rating ? <br /> : null}
            {item.rating.rating && item.rating.count
              ? `${item.rating.count} ratings`
              : null}
            {item.number_of_sales ? (
              <div className="product-list__sales-desktop">
                <BarChartIcon width="20" height="30" />
                <br />
                {item.number_of_sales ? `${item.number_of_sales} Sales` : null}
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {item.trending && <TrendingSash />}
    </div>
  )
}

ItemCardListDefault.propTypes = {
  item: PropTypes.object.isRequired,
  onAddToFavourites: PropTypes.func.isRequired,
  rank: PropTypes.number.isRequired,
  onItemLinkClick: PropTypes.func,
  onAddToCart: PropTypes.func
}

export default ItemCardListDefault
